
import { Button } from "@/components/ui/button"
import { MoonIcon, SunIcon } from "lucide-react"
import { useCustomTheme } from "@/contexts/theme-context"
import { useEffect, useState } from "react"

export function ThemeToggle() {
  const { isDarkMode, toggleDarkMode } = useCustomTheme()
  const [mounted, setMounted] = useState(false)

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <Button variant="outline" size="sm" className="flex-1" onClick={toggleDarkMode}>
      {isDarkMode ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
      <span className="sr-only">Toggle dark mode</span>
    </Button>
  )
}
